// 共通変数

const body = document.body;
const overlay = document.querySelector(".js-overlay");
const headerHeight = document.querySelector(".p-header").offsetHeight;
const mqL = window.matchMedia("(max-width: 1279px)");
const mqM = window.matchMedia("(max-width: 1023px)");
const mqS = window.matchMedia("(max-width: 767px)");

//ドロワーボタン

const dwBtn = document.querySelector(".js-menu");
const drawer = document.querySelector("#drawer-menu");
const h1 = document.querySelector("h1");

const handleChangeDW = (e) => {
  if (e.matches) {
    // ドロワーになったとき
    if (drawer.contains(document.activeElement)) {
      dwBtn.focus();
    }
    drawer.setAttribute("aria-hidden", "true");
  } else {
    // ヘッダーのとき
    if (document.activeElement === dwBtn) {
      h1.focus();
    }
    if (dwBtn.getAttribute("aria-expanded") === "true") {
      closeDrawer();
    }
    drawer.setAttribute("aria-hidden", "false");
  }
};
mqL.addEventListener("change", handleChangeDW);
handleChangeDW(mqL); // 初回実行

const closeDrawer = () => {
  if (drawer.contains(document.activeElement)) {
    dwBtn.focus();
  }
  drawer.classList.remove("is-open");
  dwBtn.classList.remove("is-open");
  overlay.classList.remove("is-open");
  body.classList.remove("is-open");
  drawer.setAttribute("aria-hidden", "true");
  dwBtn.setAttribute("aria-expanded", "false");
  dwBtn.setAttribute("aria-label", "メニューを開く");
};

dwBtn.addEventListener("click", () => {
  drawer.classList.toggle("is-open");
  dwBtn.classList.toggle("is-open");
  overlay.classList.toggle("is-open");
  body.classList.toggle("is-open");

  const isOpen = drawer.classList.contains("is-open"); //is-openがついてるか確認

  dwBtn.setAttribute("aria-expanded", isOpen); //このメニューがひらいてるかどうか
  drawer.setAttribute("aria-hidden", !isOpen); //このクラスを読み上げるかどうか

  if (isOpen) {
    dwBtn.setAttribute("aria-label", "メニューを閉じる");
  } else {
    dwBtn.setAttribute("aria-label", "メニューを開く");
  }
});

drawer.addEventListener("click", (e) => {
  if (mqL.matches) {
    if (e.target.tagName === "A") {
      closeDrawer();
    }
  }
});

overlay.addEventListener("click", () => {
  closeDrawer();
});

// topへ戻るボタン

// const pageTop = document.querySelector(".js-pageTop");

// window.addEventListener("scroll", () => {
//   if (window.scrollY > 300) {
//     pageTop.classList.add("is-show");
//   } else {
//     pageTop.classList.remove("is-show");
//   }
// });

// スムーススクロール

document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();

    const targetId = this.getAttribute("href");
    let position;
    let offset = 0;

    if (targetId === "#") {
      position = 0;
    } else {
      const target = document.querySelector(targetId);
      if (!target) return;

      if (targetId === "#spots") {
        offset = document.querySelector(".p-spots__head").offsetHeight - 200;
      }

      position =
        target.getBoundingClientRect().top +
        window.scrollY -
        headerHeight +
        offset;
    }

    window.scrollTo({
      top: position,
      behavior: "smooth",
    });
  });
});

// パーフェクトピクセルボタン

const ppBtn = document.querySelector(".js-ppBtn");
const ppImg = document.querySelector(".js-ppImg");
const ppText = document.querySelector(".js-ppText");

ppBtn.addEventListener("click", () => {
  ppImg.classList.toggle("is-open");

  const isOpen = ppImg.classList.contains("is-open"); //is-openがついてるか確認

  if (isOpen) {
    ppBtn.setAttribute("aria-label", "パーフェクトピクセルを閉じる");
    ppText.textContent = "外す";
  } else {
    ppBtn.setAttribute("aria-label", "パーフェクトピクセルを開く");
    ppText.textContent = "検証";
  }
});

//モーダル

// 開くボタン全部取得
const mdBtns = document.querySelectorAll("[data-modal]");

// モーダル全部
const modals = document.querySelectorAll(".js-modal");

// 開く処理
mdBtns.forEach((mdBtn) => {
  mdBtn.addEventListener("click", () => {
    const target = mdBtn.dataset.modal;
    document.getElementById(target).classList.add("is-open");
    overlay.classList.add("is-open");
    body.classList.add("is-open");
  });
});

// 閉じる処理（全部のモーダルに対して）

const closeModal = () => {
  modals.forEach((modal) => {
    modal.classList.remove("is-open");
  });
  overlay.classList.remove("is-open");
  body.classList.remove("is-open");
};

modals.forEach((modal) => {
  const closeBtn = modal.querySelector(".js-modal__close");

  if (closeBtn) {
    closeBtn.addEventListener("click", closeModal);
  }
});

overlay.addEventListener("click", closeModal);

// アコーディオンメニュー
// const adItems = document.querySelectorAll(".c-accordion__item");

// adItems.forEach((adItem, i) => {
//   const adBtn = adItem.querySelector(".c-accordion__btn");
//   const content = adItem.querySelector(".c-accordion__content");
//   const line = adItem.querySelector(".c-accordion__btn-line");

//   const closeAD = () => {
//     adBtn.focus();
//     content.style.height = 0;
//     adItem.classList.remove("is-open");
//     line.classList.remove("is-open");
//     content.setAttribute("aria-hidden", "true");
//     adBtn.setAttribute("aria-expanded", "false");
//   };

//   const openAD = () => {
//     content.style.height = content.scrollHeight + "px";
//     adItem.classList.add("is-open");
//     line.classList.add("is-open");
//     content.setAttribute("aria-hidden", "false");
//     adBtn.setAttribute("aria-expanded", "true");
//   };

//   if (i === 0) {
//     openAD();
//   }

//   adBtn.addEventListener("click", () => {
//     const isOpen = adItem.classList.contains("is-open");

//     if (isOpen) {
//       closeAD();
//     } else {
//       openAD();
//     }
//   });

//   const handleChangeAD = () => {
//     const isOpen = adItem.classList.contains("is-open");

//     if (isOpen) {
//       content.style.height = "auto";
//       content.style.height = content.scrollHeight + "px";
//     }
//   };
//   mqS.addEventListener("change", handleChangeAD);
//   mqM.addEventListener("change", handleChangeAD);
//   mqL.addEventListener("change", handleChangeAD);
// });

// フォーム

const form = document.querySelector(".js-form");
form.addEventListener("submit", (e) => {
  if (!form.checkValidity()) {
    e.preventDefault();
    form.classList.add("is-error");
  }
});
